import {
  GetActiveAgentDataFromStorage,
  GetOAuthTokenByKey,
  GetSemiAuthStateStorage,
  GetStateStorage,
} from 'common/storage';

const toIdString = (value) => {
  if (value === null || value === undefined || value === '') {
    return null;
  }
  return String(value);
};

/**
 * Resolves ListGen user ID from all known client storage locations.
 * @returns {string|null}
 */
export const resolveListgenUserID = () => {
  try {
    const localState = GetStateStorage() || {};
    const userData = localState.userData || {};

    const fromUserData = toIdString(userData.listgenUserID);
    if (fromUserData) {
      return fromUserData;
    }

    const fromStateUserID = toIdString(localState.userID);
    if (fromStateUserID) {
      return fromStateUserID;
    }

    const tokenData = localState.tokenData || {};
    const fromTokenData = toIdString(tokenData.userID || tokenData.listgenUserID);
    if (fromTokenData) {
      return fromTokenData;
    }

    const fromOAuth = toIdString(GetOAuthTokenByKey('userID'));
    if (fromOAuth) {
      return fromOAuth;
    }

    const fromOAuthListgen = toIdString(GetOAuthTokenByKey('listgenUserID'));
    if (fromOAuthListgen) {
      return fromOAuthListgen;
    }

    const semiState = GetSemiAuthStateStorage() || {};
    const fromSemi =
      toIdString(semiState.listgenUserID) ||
      toIdString((semiState.userData || {}).listgenUserID);
    if (fromSemi) {
      return fromSemi;
    }

    const activeAgent = GetActiveAgentDataFromStorage() || {};
    const fromActiveAgent = toIdString(activeAgent.listgenUserID);
    if (fromActiveAgent) {
      return fromActiveAgent;
    }
  } catch {
    return null;
  }

  return null;
};

/**
 * Prefer IDs already available in the calling module; fall back to storage lookup only when needed.
 * @param {...(string|number|null|undefined)} preferredIds
 * @returns {string|undefined}
 */
export const getLogListgenUserID = (...preferredIds) => {
  for (let i = 0; i < preferredIds.length; i += 1) {
    const id = preferredIds[i];
    if (id !== null && id !== undefined && id !== '') {
      return String(id);
    }
  }
  return resolveListgenUserID() || undefined;
};
